import { render, staticRenderFns } from "./ZDMCustomReportsList.vue?vue&type=template&id=4f2c1dd0&scoped=true&"
import script from "./ZDMCustomReportsList.vue?vue&type=script&lang=js&"
export * from "./ZDMCustomReportsList.vue?vue&type=script&lang=js&"
import style0 from "./ZDMCustomReportsList.vue?vue&type=style&index=0&id=4f2c1dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2c1dd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VList,VListItem,VListItemContent,VListItemTitle,VRadio,VRadioGroup,VRow,VTooltip})
